import React from 'react';
import '../styles/CategoryPage.css';

function NewsCategory({ title, emoji, categoryName, dummyNews }) {
  const relatedNews = [
    { id: 1, title: "प्रदेश में बड़ा बदलाव का संकेत, सरकार ने दिए संकेत", date: "2h पहले" },
    { id: 2, title: "जिला प्रशासन के खिलाफ शिकायत दर्ज की गई", date: "4h पहले" },
    { id: 3, title: "क्षेत्र के विकास को लेकर अहम बैठक हुई", date: "6h पहले" }
  ];

  return (
    <div className="category-page">
      <div className="page-header">
        <h1>{emoji} {title}</h1>
        <p>नई और महत्वपूर्ण खबरें</p>
      </div>

      <div className="page-container">
        <div className="main-content">
          {dummyNews.map((news, idx) => (
            <article key={news.id} className={`news-article ${idx === 0 ? 'featured' : ''}`}>
              <img src={news.image} alt={news.title} className="article-image" />
              <div className="article-content">
                <span className="category-tag">📰 {categoryName}</span>
                <h2>{news.title}</h2>
                <p>{news.description}</p>
                <div className="article-footer">
                  <span className="time">{news.timeAgo}</span>
                  <button className="read-btn">पढ़ें →</button>
                </div>
              </div>
            </article>
          ))}
        </div>

        <aside className="sidebar">
          <div className="sidebar-box">
            <h3>📌 ट्रेंडिंग खबरें</h3>
            {relatedNews.map((news, idx) => (
              <div key={news.id} className="trending-item">
                <span className="trending-num">{idx + 1}</span>
                <div>
                  <p>{news.title}</p>
                  <small>{news.date}</small>
                </div>
              </div>
            ))}
          </div>
        </aside>
      </div>
    </div>
  );
}

export default NewsCategory;
